import { t } from 'i18next';

import { Icon } from '../UI';
import { useMobile } from '../../context/Mobile';

export const MobileBrowserAlert = () => {
  let title = t('mobileBrowserAlert.title');
  let description = t('mobileBrowserAlert.description');

  const {
    state: { mobileSignupCompleted },
  } = useMobile();

  if (mobileSignupCompleted) {
    title = t('mobileBrowserAlert.signupTitle');
    description = t('mobileBrowserAlert.signupDescription');
  }

  return (
    <div className="fixed left-0 top-0 flex flex-col p-5 h-full w-full bg-black">
      <div className={'mb-8'}>
        <Icon svgName="merlinLogo" color="lime" className="h-auto w-36" />
      </div>
      <div className={'mb-4'}>
        <img
          className="w-3/4 mx-auto "
          src="/frame_mobile.svg"
          alt="frame mobile"
        />
      </div>
      <p className="text-primary text-center font-medium text-xl">{title}</p>
      <p className="text-primary font-extralight text-center mt-5">
        {description}
      </p>
      <a
        href="https://apps.apple.com/us/app/merlin-investor/id1638350124"
        target="_blank"
      >
        <img
          className="cursor-pointer mt-10 w-1/2 h-auto mx-auto"
          src="/download_app_store.png"
          alt="app store"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.merlininvestor"
        target="_blank"
      >
        <img
          className="cursor-pointer my-5 w-1/2 h-auto mx-auto"
          src="/download_google_play.png"
          alt="play store"
        />
      </a>
    </div>
  );
};
